import {z} from "zod";

const schema = z.object({
	isFirstLogin: z.boolean(),
	accessToken: z.string(),
	refreshToken: z.string()
});

const model = schema.transform((values) => ({
	...values
}));

export const EmployeeLoginResModel = {schema, model};
export type IEmployeeLoginResModel = z.infer<typeof EmployeeLoginResModel.model>;
export const DEFAULT_EMPLOYEE_LOGIN: IEmployeeLoginResModel = {
	isFirstLogin: false,
	accessToken: "",
	refreshToken: ""
};
